<template>
  <form method="post">
    <div id="app" class="home" data-page="home">
      <div class="header">
        <div class="header-anim-box page1">
          <!-- <a
            class="header-logo"
            href="https://acts.leiting.com/wf/202105/fab/"
            target="_blank"
          >
            <img src="@assets/images/lanhu/dianjiguanzhu.png" alt="" />
            <span class="guanzhu">已有<span>{{ initData.base_info.attention }}</span>人关注</span>
          </a> -->
          <div class="header-anim">
            <div class="header-anim__bg">
              <img
                style="width: 100%"
                src="https://ossstatic.leiting.com/static/wf/202210/pc/anim-bg.jpg"
                alt=""
              />
            </div>
            <div class="header-anim__mbg">
              <img
                src="https://ossstatic.leiting.com/static/wf/202210/move/mbg.jpg.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 适龄标识 -->
        <!-- <div id="age" class="age">
          <a
            href="https://worldflipper.leiting.com/news-detail?id=186"
            target="_blank"
          >
            <img
              src="https://ossstatic.leiting.com/static/mole/202105/images/age.png"
              style="width: 0.9rem"
            />
          </a>
        </div> -->
      </div>
      <!-- <div class="main-banner-wrap">
        <a href="javascript:;" class="main-banner" target="_blank">
          <img src="" alt="" />
        </a>
      </div> -->
      <div class="main">
        <div class="main-nav">
          <ul class="main-nav__ul">
            <li class="main-nav__li">
              <router-link
                :to="{ path: '/news' }"
                class="main-nav__li-a main-nav__li-news"
                >公告</router-link
              >
            </li>
            <li class="main-nav__li">
              <router-link
                :to="{ path: '/story' }"
                class="main-nav__li-a main-nav__li-story"
                >剧情</router-link
              >
            </li>
            <li class="main-nav__li">
              <router-link
                :to="{ path: '/character' }"
                class="main-nav__li-a main-nav__li-char"
                >角色</router-link
              >
            </li>
            <li class="main-nav__li">
              <router-link
                :to="{ path: '/gamesystem' }"
                class="main-nav__li-a main-nav__li-gamesystem"
                >游戏系统</router-link
              >
            </li>
            <li class="main-nav__li">
              <div
                class="main-nav__inner-title"
                @mouseenter="navInnerEnter"
                @mouseleave="navInnerLeave"
              >
                Special
              </div>
              <ul
                class="main-nav__inner-ul"
                @mouseenter="navInnerChildEnter"
                @mouseleave="navInnerChildLeave"
              >
                <li class="main-nav__inner-li">
                  <router-link
                    :to="{ path: '/downloads' }"
                    class="main-nav__inner-downloads"
                    >下载专区</router-link
                  >
                </li>
                <li class="main-nav__inner-li">
                  <router-link
                    :to="{ path: '/movie' }"
                    class="main-nav__inner-movies"
                    >影片</router-link
                  >
                </li>
              </ul>
            </li>
            <li class="main-nav__li">
              <a
                href="https://actscp.leiting.com/wf/act/202307/redemption/"
                class="main-nav__li-a main-nav__li-cdkey"
                target="_blank"
                >礼包码兑换</a
              >
            </li>
          </ul>
        </div>
        <div class="main__downloadapp">
          <div class="main__downloadapp-group">
            <a
              id="m_android_download"
              :href="downloadUrl.android_url || 'javascript:;'"
              class="main__downloadapp-app"
            ></a>
            <a
              id="m_appstore_download"
              :href="downloadUrl.ios_url || 'javascript:;'"
              class="main__downloadapp-goo"
              v-if="
                initData.base_info.appstore_download_status !== '2' &&
                  !this.isAndroid
              "
            ></a>
            <a
              id="m_taptap_download"
              :href="initData.base_info.taptap_download"
              class="main__downloadapp-tap"
              v-if="
                initData.base_info.taptap_download_status !== '2' && !this.mid
              "
            ></a>
          </div>
        </div>
        <div class="main__info-wrap">
          <div class="main__news-block">
            <div class="main__news-title">公告</div>
            <div class="main__news-box" id="main__news-box">
              <div class="main__news-inner" id="main__news-inner">
                <ul class="main__news-inner__list" id="main__news-inner__list">
                  <li
                    class="main__news__li"
                    v-for="(item, index) in news_list"
                    :key="index"
                  >
                    <router-link
                      :class="
                        `main__news__link ${newsType(item.class_id).class}`
                      "
                      :to="{ path: '/news-detail?id=' + item.content_id }"
                    >
                      <div class="main__news__info">
                        <span class="main__news__info-time">{{
                          item.create_time
                        }}</span>
                        <span class="main__news__info-text">{{
                          newsType(item.class_id).text
                        }}</span>
                      </div>
                      <div class="main__news__title">
                        <span class="main__news__title-text">{{
                          item.title
                        }}</span>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="main__fb-block">
            <div class="main__fb-title"></div>
            <div class="main__news-box">
              <div class="main__news-inner" id="main__fb-box">
                <ul class="main__news-inner__list" id="main__fb-box_list"></ul>
              </div>
            </div>
          </div>
          <div class="main__total-block">
            <div class="main__total-title">PV</div>
            <div class="main__total-video-box">
              <a
                href="javascript:;"
                data-video=""
                class="main__total-video video-popup"
                :style="
                  'background-image:url(' + baseUrl + pv_video.video_img + ')'
                "
                @click="onMainTotalVideo"
              >
                <img :src="baseUrl + pv_video.video_img" alt="" />
              </a>
            </div>
            <div class="main__total-box">
              <div class="main__total-inner">
                <a
                  id="wechat_qr_code"
                  href="javascript:;"
                  class="main__total-link main__total-fb"
                  @click="popShow = !popShow"
                ></a>
                <a
                  id="QQ_group"
                  href="https://jq.qq.com/?_wv=1027&k=J1JCI7fF"
                  class="main__total-link main__total-yt"
                  target="_blank"
                ></a>
                <a
                  id="weibo"
                  :href="initData.base_info.weibo"
                  class="main__total-link main__total-ig"
                  target="_blank"
                ></a>
                <a
                  id="taptap"
                  :href="initData.base_info.taptap"
                  v-if="initData.base_info.taptap_download_status !== '2'"
                  class="main__total-link main__total-baha"
                  target="_blank"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup" v-show="popShow">
        <div class="popBg">
          <div class="popout" @click="popShow = !popShow"></div>
          <div class="popQr"></div>
        </div>
      </div>
      <div class="home-char">
        <div class="home-char-title"></div>
        <div class="home-char-slider-wrap">
          <div class="home-char-slider-box" v-html="charHtml">
            <!-- <div class="home-char-slider-box"> -->
            <!-- <a
              v-for="item in palyer_list"
            :to="{ path: '/character-detail?id=' + item.sortid }"
              :key="item.sortid"
              class="home-char-slider "
            >
              <div class="home-char-slider__img">
                <img :src="baseUrl + item.player_img" alt="" />
              </div>
              <div class="home-char-slider__gif">
                <img :src="baseUrl + item.pic" alt="" />
              </div>
              <div class="home-char-slider__info">
                <p class="home-char-slider__info-name">恩妮</p>
                <p class="home-char-slider__info-cv">CV：藤田茜</p>
                <p class="home-char-slider__info-type">属性：火</p>
              </div>
            </a> -->
          </div>
          <!-- 自定義的 上一頁 -->
          <a href="javascript:;" class="home-char-slider-prev"></a>
          <!-- 自定義的 下一頁 -->
          <a href="javascript:;" class="home-char-slider-next"></a>
        </div>
        <router-link :to="{ path: '/character' }" />
      </div>

      <div class="bottom-wrap">
        <div class="bottom">
          <div class="bottom-desc-wrap">
            <div class="bottom-desc__logo"></div>
            <div class="bottom-desc__text" id="index_bottom_info">
              <div class="bottom-desc__text-block">
                <div class="bottom-desc__text-title">游戏名称：</div>
                <div class="bottom-desc__text-content">
                  WORLD FLIPPER（弹射世界）
                </div>
              </div>
              <div class="bottom-desc__text-block">
                <div class="bottom-desc__text-title">类型：</div>
                <div class="bottom-desc__text-content">
                  爽快连击弹珠动作游戏
                </div>
              </div>
              <div class="bottom-desc__text-block">
                <div class="bottom-desc__text-title">价格：</div>
                <div class="bottom-desc__text-content">
                  基本免费（游戏内含部分付费道具）
                </div>
              </div>
              <div class="bottom-desc__text-block">
                <div class="bottom-desc__text-title">主机平台：</div>
                <div class="bottom-desc__text-content">
                  <span
                    ><span class="bottom-desc__text-content-title"
                      >主机平台：</span
                    >iOS/Android</span
                  >
                  <span>【iOS 版本】系统需求：iOS 10.0 以上的版本</span>
                  <span>【Android 版本】系统需求：Android 5.0 以上的版本</span>
                </div>
              </div>
            </div>
            <div class="bottom-desc__dl-list">
              <a
                target="_blank"
                id="m_bottom_appstore_download"
                :href="downloadUrl.ios_url || 'javascript:;'"
                class="bottom-desc__dl-app"
                v-if="initData.base_info.appstore_download_status !== '2'"
                >appstore</a
              >
              <a
                target="_blank"
                id="m_bottom_android_download"
                :href="downloadUrl.android_url || 'javascript:;'"
                class="bottom-desc__dl-goo1"
                >taptap</a
              >
              <a
                target="_blank"
                id="m_bottom_android_download"
                :href="initData.base_info.taptap_download"
                class="bottom-desc__dl-goo"
                v-if="
                  initData.base_info.taptap_download_status !== '2' && !this.mid
                "
                >taptap</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { mapGetters } from "vuex";
import { index } from "@api/index";
import { VUE_APP_API_URL, isAndroid } from "@utils/index";

export default {
  name: "home",
  components: {},
  data() {
    return {
      popShow: false,
      baseUrl: VUE_APP_API_URL,
      menuOpen: false,
      palyer_list: [],
      news_list: [],
      pv_video: {},
      charHtml: "",
      isAndroid: isAndroid(),
      mid: ""
    };
  },
  computed: mapGetters(["initData", "downloadUrl"]),
  watch: {
    initData(e) {
      if (!e.frament.length) return;
      let that = this;
      e.frament.map(e => {
        const __content = that
          .$("<div>")
          .html(e.content)
          .text();
        if (e.position === "index_footer") {
          //首页底部
          that.$("#index_bottom_info").html(__content);
        }
      });
    }
  },
  mounted: function() {
    /* if ($route.meta.keepAlive) {
      window.LTFooter.setAge();
    } */
    window.LTFooter.setAge();
    window.$(".header-bar__download").addClass("top0");

    let that = this;
    // console.log(window.mid);
    index().then(res => {
      // console.log(res);
      // console.log(res.palyer_list);
      for (var i = 0; i < res.palyer_list.length; i++) {
        res.palyer_list[i].class_id = Number(res.palyer_list[i].class_id);
        res.palyer_list[i].content_id = Number(res.palyer_list[i].content_id);
        res.palyer_list[i].data_id = Number(res.palyer_list[i].data_id);
        res.palyer_list[i].rarity = Number(res.palyer_list[i].rarity);
        res.palyer_list[i].sex = Number(res.palyer_list[i].sex);
        res.palyer_list[i].sortid = Number(res.palyer_list[i].sortid);
        res.palyer_list[i].status = Number(res.palyer_list[i].status);
        res.palyer_list[i].type = Number(res.palyer_list[i].type);
      }
      that.palyer_list = res.palyer_list;
      // console.log(that.palyer_list);
      that.pv_video = res.pv_video;
      // res.news_list.create_time = res.news_list.create_time.replace(/-/g, ".").slice(0, 10);
      // [0].create_time
      // console.log(res.news_list.length);
      // eslint-disable-next-line no-redeclare
      for (var i = 0; i < res.news_list.length; i++) {
        res.news_list[i].create_time = res.news_list[i].create_time.slice(
          0,
          10
        );
        res.news_list[i].class_id = Number(res.news_list[i].class_id);
      }
      that.news_list = res.news_list;
      // console.log(that.news_list);
      that.genActivity(res.activity);
      if (res.news_list.length > 0) {
        this.$("#main__news-inner").mCustomScrollbar({
          theme: "light-3",
          scrollButtons: {
            enable: false
          },
          scrollInertia: 0,
          mouseWheelPixels: 50
        });
      }
      if (res.palyer_list.length > 0) {
        let HTML = "";
        that.palyer_list.forEach(element => {
          HTML += that.charRender(element);
        });
        this.$(".home-char-slider-box").html(HTML);
        this.tns({
          container: ".home-char-slider-box",
          items: 1,
          center: true,
          loop: true,
          swipeAngle: false,
          speed: 400,
          edgePadding: 20,
          autoplayButtonOutput: false,
          prevButton: ".home-char-slider-prev", // 自定義的 上一頁
          nextButton: ".home-char-slider-next", // 自定義的 下一頁
          nav: false,
          mouseDrag: true,
          responsive: {
            769: {
              edgePadding: 40,
              items: 5,
              fixedWidth: 420
            }
          }
        });
      }

      // console.log(window.mid);
      that.mid = window.mid;
      // console.log(that.mid);

      window.$("#app").addClass("loaded");
    });
    // getAdClient().then(res => {
    //   if (res.data.length === 0) {
    //     that.$(".main-banner-wrap").hide();
    //     return;
    //   }
    //   that.$(".main-banner-wrap").show();
    //   that
    //     .$(".main-banner")
    //     .html("<img src=" + res.data[0].SourceFile + " alt=''>");
    //   that.$(".main-banner").attr("href", res.data[0].ADUrl);
    // });
    // var ltPhoneLogin = new that.LtPhoneLogin({
    //   id: "activity",
    //   gameType: "wf",
    //   choose: true,
    //   phoneCodeUrl: "//actsapi.leiting.com/common/api/sendPhoneCode",
    //   callBackUrl: "//actsapi.leiting.com/api/phoneCheck",
    //   callbackData: {
    //     game: "wf",
    //     type: 75 // ID
    //   },
    //   callBackFn: function() {
    //     alert("");
    //   }
    // });
    // document.getElementById("showwatchform").addEventListener("click", () => {
    //   ltPhoneLogin.show();
    // });
  },
  methods: {
    genActivity(activity) {
      let that = this;
      var HTML = "";
      activity.forEach(function(v) {
        HTML += `
                <li style="padding:5px; ">
                    <a href="${v.jump_url || "javascript:;"}">
                        <img style="width:100%;border-radius: 5px;" src="${that.baseUrl +
                          v.banner}" alt="${v.title}">
                    </a>
                </li>
                `;
      });
      this.$("#main__fb-box_list").html(HTML);

      if (this.$("#main__fb-box").length) {
        this.$("#main__fb-box").mCustomScrollbar({
          theme: "light-3",
          scrollButtons: {
            enable: false
          },
          scrollInertia: 0,
          mouseWheelPixels: 50
        });
      }
    },
    onMainTotalVideo() {
      const url = this.pv_video.image.includes("http")
        ? this.pv_video.image
        : `${this.baseUrl + this.pv_video.image}`;
      this.$.gbox.open(
        `
                <div class="lb-video-box 222">
                        <iframe width="560" height="315" src="${url}" 
                          frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>

                `,
        {
          addClass: "video-lb",
          hasCloseBtn: true,
          hasActionBtn: false,
          afterClose: function() {
            this.$.gbox.close();
          }
        }
      );
    },
    navInnerEnter() {
      this.menuOpen = true;
      this.$(".main-nav__inner-ul").fadeIn();
    },
    navInnerLeave() {
      let that = this;
      that.menuOpen = false;
      setTimeout(function() {
        if (!that.menuOpen) this.$(".main-nav__inner-ul").fadeOut();
      }, 300);
    },
    navInnerChildEnter() {
      this.menuOpen = true;
    },
    navInnerChildLeave() {
      let that = this;
      that.menuOpen = false;
      setTimeout(function() {
        if (!that.menuOpen) this.$(".main-nav__inner-ul").fadeOut();
      }, 300);
    },
    propertyNumNameChange(property) {
      switch (property) {
        case "0":
          return {
            property: "火",
            en: "red",
            seq: "0"
          };
        case "1":
          return {
            property: "水",
            en: "blue",
            seq: "1"
          };

        case "2":
          return {
            property: "风",
            en: "green",
            seq: "2"
          };
        case "3":
          return {
            property: "雷",
            en: "yellow",
            seq: "3"
          };
        case "4":
          return {
            property: "光",
            en: "white",
            seq: "4"
          };
        case "5":
          return {
            property: "暗",
            en: "black",
            seq: "5"
          };
        default:
          return {
            property: "all",
            seq: "0",
            en: "red"
          };
      }
    },
    newsType(type) {
      switch (type) {
        case 3:
          return {
            text: "新闻",
            class: "news-event"
          };
        case 4:
          return {
            text: "公告",
            class: "news-update"
          };
        case 5:
          return {
            text: "活动",
            class: "news-important"
          };

        case 6:
          return {
            text: "本地化",
            class: "news-locale"
          };
        default:
          return {
            text: "其他公告",
            class: "news-error"
          };
      }
    },
    charRender(data) {
      var charHTML =
        "<a data-id=" +
        data.content_id +
        ' href="/character-detail?id=' +
        data.content_id +
        '" class="home-char-slider">\
                <div class="home-char-slider__img">\
                    <img src="' +
        this.baseUrl +
        data.player_img +
        '" alt="">\
                </div>\
                <div class="home-char-slider__gif">\
                    <img src="' +
        this.baseUrl +
        data.pic +
        '" alt="">\
                    </div>\
                <div class="home-char-slider__info">\
                    <p class="home-char-slider__info-name">' +
        data.title +
        '</p>\
                    <p class="home-char-slider__info-cv">CV：' +
        data.cv_desc +
        '</p>\
                    <p class="home-char-slider__info-type">属性：' +
        this.propertyNumNameChange(data.attributes).property +
        "</p>\
                </div>\
            </router-link>";
      return charHTML;
    }
  }
};
</script>
<style scoped>
#age {
  position: absolute;
  right: 40px;
  top: 70px;
  z-index: 102;
}
</style>
